export const OTP_REQUIRED = 'OTP code is required';
export const INVALID_OTP = 'Invalid OTP code';
export const INVALID_OTP_LENGTH = 'OTP code must be exactly 4 digits';
